/**
 * Brands page — preserves the original cinematic explainer experience
 * as the Story/Brands page of the new B2B site.
 */
import SceneLogo from "@/components/SceneLogo";
import SceneBrands from "@/components/SceneBrands";
import SceneLeadership from "@/components/SceneLeadership";
import ScrollProgress from "@/components/ScrollProgress";

export default function Brands() {
  return (
    <div data-testid="page-brands" className="bg-cream pt-20">
      <ScrollProgress />
      <SceneLogo />
      <SceneBrands />
      <SceneLeadership />
    </div>
  );
}
